import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from 'react-bootstrap';

class ActionButtonListItemComponent extends React.Component {
  static propTypes = {
    action: PropTypes.oneOfType(
      [
        PropTypes.shape(
          {
            title: PropTypes.string.isRequired,
            onSelect: PropTypes.func.isRequired,
            isDisabled: PropTypes.bool.isRequired
          }).isRequired,
        PropTypes.shape(
          { isSeparator: PropTypes.bool.isRequired }).isRequired
      ]
    ),
    actionKey: PropTypes.string.isRequired,
    onButtonClick: PropTypes.func.isRequired
  };

  render() {
    const {
      action,
      actionKey,
      onButtonClick
    } = this.props;

    if (action.isSeparator) {
      return (<MenuItem key={actionKey} divider />);
    }
    else {
      return action.onSelect ? (
        <MenuItem
          key={actionKey}
          onSelect={() => onButtonClick(action.onSelect)}
          disabled={action.isDisabled}
        >
          {action.title}
        </MenuItem>) : null;
    }
  }
}

export default ActionButtonListItemComponent;


// WEBPACK FOOTER //
// src/Components/ActionButtonListItemComponent.jsx